// ImageSlider.js
import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';

const images = [
  {
    id: 1,
    header: "Solargraf: AI powered Solar Design & Sales app",
    thumbnail: "solargrafthumbnail.png",
    type: "B2B | Web App | Product Scale up | UI revamp",
    content: "Created and executed a 3 year scale up roadmap to relaunch the product with best-in-market features and a new UI design",
    link: "https://app.solargraf.com/",
    newslink: "https://investor.enphase.com/news-releases/news-release-details/enphase-energy-expands-solargraf-platform-new-design-proposal"
  },
  {
    id: 8,
    header: "AI powered EdTech app",
    thumbnail: "edtechapp.png",
    type: "B2C | Android, iOS App | Product Launch | Startup",
    content: "Designed the full user journey and defined all key features for an edtech app using AI to empower students in preparing for competitive exams",
    link: "",
    newslink: ""
  },
  {
    id: 2,
    header: "3D Design & Permit Automation",
    thumbnail: "designtoolpermit.png",
    type: "B2B | AI | GIS Imagery",
    content: "Developed a 3D design tool for solar panel placement and simulation. Extended further by adding ability to make electrical connections and generate permit ready files",
    link: "https://www.solargraf.com/get-install-ready-permit-plan-sets/",
    newslink: ""
  },
  {
    id: 6,
    header: "Solargraf API platform",
    thumbnail: "solargrafapis.png",
    type:"B2B | API | New Launch",
    content: "Created an API platform to allow seamless worklflow integration between installer CRMs & Solargraf",
    link: "https://developer.solargraf.com",
    newslink: "https://www.linkedin.com/posts/solargraf_solargraf-apis-crms-activity-7112465853975019520-6hFy/"
  },
  {
    id: 3,
    header: "Solar System Planner Tool for Homeowners",
    thumbnail: "systemplannerthumbnail.png",
    type: "B2C | Utility integrations | Appliance management",
    content: "Launched an AI-based solar recommendation and panel visualisation web application for potential solar buyers. Integrated with Salesforce",
    link: "https://estimator.enphase.com/v3",
    newslink: ""
  },
  {
    id: 7,
    header: "Digital Services for Solar installers",
    thumbnail: "3services.png",
    type: "B2C | SaaS | Ease of installation",
    content: "Created a set of 3 services that allowed installers to easily submit requests for otherwise complicated steps in solar installation",
    link: "https://enlighten.enphase.com/",
    newslink: ""
  },
  {
    id: 4,
    header: "Airtel Next Gen Retail Stores",
    thumbnail: "airtelnextgenstore.jpg",
    type: "B2C | Android Apps | Touchscreen experiences",
    content: "Pioneered an experiential retail concept in Airtel stores in collaboration with a UK-based design consultancy. Implemented interactive digital experiences via android apps on large touchscreens and tablets",
    link: "",
    newslink: "https://www.airtel.in/press-release/02-2019/airtel-launches-its-next-gen-stores-in-kolkata"
  },
  {
    id: 5,
    header: "Retail App & Web Portal",
    thumbnail: "bioattendanceapp.png",
    type: "Internal | Android app | Biometric",
    content: "Launched a web and android app to digitize hiring and operational procedures resulting in improved efficiency, decreased errors, and higher employee satisfaction",
    link: "",
    newslink: ""
  },


];

const Products = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const intervalRef = useRef(null);

  const setScrollInterval = () => {
    intervalRef.current = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 10000); // Change image every 10 seconds
  };

  useEffect(() => {
    setScrollInterval();
    return () => clearInterval(intervalRef.current);
  }, []);

  const goToSlide = (index) => {
    setCurrentIndex(index);
    resetScrollInterval();
  };

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    resetScrollInterval();
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
    resetScrollInterval();
  };

  const resetScrollInterval = () => {
    clearInterval(intervalRef.current);
    setScrollInterval();
  };

  return (
    <SliderContainer>
      {/* <p className='pmp-title'>Products I've worked on</p> */}
      <Dots>
        <ArrowLeft onClick={prevSlide}>&#x276E;</ArrowLeft>
        {images.map((_, index) => (
          <Dot key={index} active={currentIndex === index} onClick={() => goToSlide(index)} />
        ))}
        <ArrowRight onClick={nextSlide}>&#x276F;</ArrowRight>
      </Dots>
      <div className='ImageContainer'>
        <Image src={images[currentIndex].thumbnail} alt={`Slide ${currentIndex + 1}`} />
        <div className='pmp-content'>
          <p className='pmp-header'>{images[currentIndex].header}</p>
          <p className='pmp-type'>{images[currentIndex].type}</p>
          <p className='pmp-desc'>{images[currentIndex].content}</p>
          {images[currentIndex].newslink && <button className='pmp-button'><a className='pmp-link' target='_blank' rel="noreferrer" href={images[currentIndex].newslink}>News Coverage</a></button>}
          {images[currentIndex].link && <button ><a className='pmp-link' target='_blank' rel="noreferrer" href={images[currentIndex].link}>Product Link</a></button>}
        </div>
      </div>



    </SliderContainer>
  );
};

export default Products;

const SliderContainer = styled.div`
  position: relative;
  width: 100%;
  margin: auto;
  overflow: hidden;
`;

// const ImageContainer = styled.div`
//   position: relative;
//   display:flex;
// `;

const Image = styled.img`
  width: 50%;
  max-height:400px;
  object-fit: contain;
  border-radius: 12px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  transition: box-shadow 0.3s ease-in-out;
  &:hover {
    box-shadow: 0 16px 32px rgba(0, 0, 0, 0.4);
  }
`;

const Dots = styled.div`
  text-align: center;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 16px;
  margin-bottom: 16px;
`;

const Dot = styled.span`
  width: 10px;
  height: 10px;
  margin: 0 5px;
  background-color: ${(props) => (props.active ? '#094024' : '#bbb')};
  border-radius: 50%;
  cursor: pointer;
`;

const Arrow = styled.div`
  // position: absolute;
  // top: 2%;
  // transform: translateY(-50%);
  font-size: 1.5rem;
  color: #094024;
  background-color: rgba(0, 0, 0, 0.0);
  padding: 10px;
  cursor: pointer;
  z-index: 2;
  user-select: none;
  border-radius:30px;
`;

const ArrowLeft = styled(Arrow)`
  // left: 40%;
`;

const ArrowRight = styled(Arrow)`
  // right: 40%;
`;
